import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { ConfirmActionDialog } from "@/components/ui/confirm-action-dialog";
import type { ReactNode } from "react";

interface SwapSendFooterProps {
  canSend: boolean;
  isUploading: boolean;
  isSendDialogOpen: boolean;
  onOpenSendDialog: () => void;
  onCloseSendDialog: () => void;
  onConfirmSend: () => void;
  extraButtons?: ReactNode;
}

export function SwapSendFooter({
  canSend,
  isUploading,
  isSendDialogOpen,
  onOpenSendDialog,
  onCloseSendDialog,
  onConfirmSend,
  extraButtons,
}: SwapSendFooterProps) {
  return (
    <>
      <div className="border-t border-gray-200 bg-white p-4">
        {extraButtons}
        <button
          type="button"
          onClick={onOpenSendDialog}
          disabled={!canSend || isUploading}
          className={cn(
            "w-full rounded-full py-4 text-base font-semibold transition-colors",
            canSend && !isUploading
              ? "bg-black text-white hover:bg-gray-800"
              : "cursor-not-allowed bg-gray-200 text-gray-400",
          )}
        >
          {isUploading ? (
            <span className="flex items-center justify-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              Sending...
            </span>
          ) : (
            "Send"
          )}
        </button>
      </div>

      <ConfirmActionDialog
        isOpen={isSendDialogOpen}
        onClose={onCloseSendDialog}
        onConfirm={onConfirmSend}
        title="Send this swap?"
        description="Your teen will receive this swap and can respond with their own photo."
        loading={isUploading}
        confirmVariant="default"
        confirmText="Send"
      />
    </>
  );
}
